import component from "./AllResultsHome";

export default component;
